import { render, staticRenderFns } from "./DayPercentages.vue?vue&type=template&id=0c466f96"
import script from "./DayPercentages.vue?vue&type=script&lang=js"
export * from "./DayPercentages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports